import { Injectable } from '@angular/core';

Injectable()
export class Globals {
    private _timestamp: string;
    private _datetime: string;
    private _longdate: string;
    private _longtime: string;
    private _shortdate: string;
    private _shorttime: string;
    private _time: string;
    private _firstdayofweek: string;
    private _inputDate: string;
    private days = {
        sunday: 0,
        monday: 1,
        tuesday: 2,
        wednesday: 3,
        thursday: 4,
        friday: 5,
        saturday: 6
    };

    get TIMESTAMP(): string {
        return this._timestamp;
    }

    set TIMESTAMP(val: string) {
        this._timestamp = val;
    }

    get DATETIME(): string {
        return this._datetime;
    }

    set DATETIME(val: string) {
        this._datetime = val;
    }

    get LONGDATE(): string {
        return this._longdate;
    }

    set LONGDATE(val: string) {
        this._longdate = val;
    }

    get LONGTIME(): string {
        return this._longtime;
    }

    set LONGTIME(val: string) {
        this._longtime = val;
    }

    get SHORTDATE(): string {
        return this._shortdate;
    }

    set SHORTDATE(val: string) {
        this._shortdate = val;
    }

    get SHORTTIME(): string {
        return this._shorttime;
    }

    set SHORTTIME(val: string) {
        this._shorttime = val;
    }

    get TIME(): string {
        return this._time;
    }

    set TIME(val: string) {
        this._time = val;
    }

    get INPUTDATE(): string {
        return this._inputDate;
    }

    set INPUTDATE(val: string) {
        this._inputDate = val;
    }


    get FIRSTDAYOFWEEK(): number {
        if (!this._firstdayofweek) {
           return this.days["sunday"];
        }
        return this.days[this._firstdayofweek.toLowerCase()];
    }

    set FIRSTDAYOFWEEK(val: string) {
        this._firstdayofweek = val;
    }

    public EMAIL_PATTERN = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,63}$';
    public static CODE_PATTERN = '^[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])+$';
    public NAME_PATTERN = /^[\p{L} ]*$/u;
    public PASSWORD_PATTERN = /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\D*\d)(?!.* ).{8,}$/;
    public readonly ERROR_PASSWORD_RECYCLE = 'Password has to be different from the old one.';
}